export const POINT_ENDPOINTS = {
  USER: {
    MY_STORE_POINTS:
      '/api/v2/users/me/store-points',
  },

  ADMIN: {
    USER_POINTS: (
      userId: string,
    ) =>
      `/api/v2/admin/users/${userId}/points`,

    USER_STORE_POINTS: (
      userId: string,
    ) =>
      `/api/v2/admin/users/${userId}/store-points`,

    GRANT_STORE_POINTS: (
      userId: string,
    ) =>
      `/api/v2/admin/users/${userId}/store-points/grant`,
  },

  SUPERADMIN: {
    MINT:
      '/api/v2/superadmin/points/mint',

    GIVE_TO_ADMIN: (
      adminId: number,
    ) =>
      `/api/v2/superadmin/admins/${adminId}/points`,
  },
} as const;